// External Imports
import { useContext } from "react";

// Internal Imports
import { UtilityContext } from "../../context/util-context";

/** ========================================================================
 * * Location Card Component
 * Renders a card displaying Location information.
 * ========================================================================== */

export default function LocationCard({ location }) {
  const { navigate } = useContext(UtilityContext);

  const classNames = () => {
    let classes =
      "grid items-center lg:grid-cols-7 gap-4 text-sm pill border-stone-400";
    if (!location.active) classes += " opacity-40";
    return classes;
  };

  return (
    <div
      onClick={(e) => navigate(`/locations/info?id=${location.id}`, e)}
      className={classNames()}
    >
      <div className="flex items-center space-x-4">
        <img src={location.image} className="w-10 h-10 rounded-full" />
        <p className="font-semibold text-stone-200">{location.name}</p>
      </div>
      <div className="text-center lg:col-span-2">
        <p className="text-stone-200">{location.address || "-"}</p>
      </div>
      <div className="hidden text-center lg:block">
        <p className="text-stone-200">{location.phone || "-"}</p>
      </div>
      <div className="hidden text-center lg:block">
        <p className="text-stone-200">
          {location.tax ? `${Number(location.tax * 100).toFixed(2)}%` : "-"}
        </p>
      </div>
      <div className="hidden text-center lg:block">
        <p className="text-stone-200">
          {location.active ? "Active" : "Inactive"}
        </p>
      </div>
      <p className="hidden font-semibold lg:block text-stone-200">{location.id}</p>
    </div>
  );
}
